<template>
  <div v-loading="loading" class="lad-reviews--product">
    <template v-if="reviews.length > 0">
      <ul class="list-unstyled">
        <li v-for="item in itemsList" :key="item.uuid">
          <LadReviewCard
            :review="item.review"
            :uuid="item.uuid"
            :message="item.message"
            :score="item.score"
            :likes_dislikes="item.likes_dislikes"
            :created_at="item.created_at"
            :_user="item._user"
            :comments="item.comments"
          />
        </li>
      </ul>

      <div>
        <el-pagination
          layout="total, prev, pager, next"
          :total="reviewsList.length"
          :pager-count="5"
          :page-size="pageSize"
          background
          @current-change="handleCurrentChange"
        />
      </div>
    </template>

    <el-card v-else shadow="hover" class="without_reviews">
      <h2>{{ $t(`${base}.without_reviews.title`) }}</h2>
      <p>{{ $t(`${base}.without_reviews.description`) }}</p>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import LadReviewCard from './card'

export default {
  name: 'LadReviewsProduct',
  components: {
    LadReviewCard,
  },
  props: {
    uuid: { type: String, required: true },
  },
  data() {
    return {
      base: 'components.reviews',
      loading: false,
      currentPage: 1,
      pageSize: 5,
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('reviews', {
      reviews: 'reviews',
      reviewsSearch: 'search',
    }),
    reviewsList() {
      return this.reviewsSearch
        ? this.reviews.filter((review) => {
            const message = review.message.removeDiacritical()
            const search = this.reviewsSearch.removeDiacritical()

            return message.includes(search)
          })
        : this.reviews
    },
    itemsList() {
      const prevPage = this.currentPage - 1
      const start = prevPage !== 0 ? prevPage * this.pageSize : 0
      const end = this.currentPage * this.pageSize

      return this.reviewsList.slice(start, end)
    },
  },
  watch: {
    uuid: {
      immediate: true,
      handler(value) {
        if (process.server) return

        if (value) this.init()
      },
    },
  },
  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {}
  },
  beforeDestroy() {
    try {
      this.$recaptcha.destroy()
    } catch (e) {}
  },
  methods: {
    async init() {
      this.loading = true
      const firstReview = this.$route.query.first_review || ''
      const data = {
        product: { uuid: this.uuid },
        firstReview: { uuid: firstReview },
      }

      try {
        await this.$store.dispatch('reviews/getProductReviews', data)

        if (firstReview) {
          this.handleScroll(firstReview)
        }
      } catch (error) {}

      this.loading = false
    },
    handleScroll(uuid) {
      const showCommentsBtn = document.querySelector(
        `#review-comments-btn-${uuid}`
      )

      const offset = this.isMobile ? -550 : 0

      this.$scrollTo(showCommentsBtn, 1000, { offset })

      showCommentsBtn.click()
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
  },
}
</script>

<style lang="scss">
.lad-reviews--product {
  .without_reviews {
    p {
      margin-bottom: 1em;
    }
  }

  .list-unstyled {
    li {
      padding: 0;

      i {
        position: inherit;
        left: inherit;
        top: inherit;
      }

      & + li {
        margin-top: 20px;
      }
    }
  }
}
</style>
